var map = {
	"./answerQuestion": [
		27765,
		7765
	],
	"./answerQuestion.tsx": [
		27765,
		7765
	],
	"./carousel": [
		19137,
		9137
	],
	"./carousel.tsx": [
		19137,
		9137
	],
	"./caseStudy": [
		7848,
		7848
	],
	"./caseStudy.tsx": [
		7848,
		7848
	],
	"./download": [
		88607,
		8607
	],
	"./download.tsx": [
		88607,
		8607
	],
	"./fillBlankDropdown": [
		33124,
		3124
	],
	"./fillBlankDropdown.tsx": [
		33124,
		3124
	],
	"./fillBlankText": [
		85487,
		5487
	],
	"./fillBlankText.tsx": [
		85487,
		5487
	],
	"./look": [
		74265,
		4265
	],
	"./look.tsx": [
		74265,
		4265
	],
	"./markYourself": [
		53309,
		3309
	],
	"./markYourself.tsx": [
		53309,
		3309
	],
	"./mcq": [
		79990,
		9990
	],
	"./mcq.tsx": [
		79990,
		9990
	],
	"./opinion": [
		73501,
		3501
	],
	"./opinion.tsx": [
		73501,
		3501
	],
	"./opinionOpen": [
		73137,
		3137
	],
	"./opinionOpen.tsx": [
		73137,
		3137
	],
	"./other": [
		72611,
		2611
	],
	"./other.tsx": [
		72611,
		2611
	],
	"./questionAndAnswer": [
		37544,
		7544
	],
	"./questionAndAnswer.tsx": [
		37544,
		7544
	],
	"./randomGenerator": [
		88545,
		8545
	],
	"./randomGenerator.tsx": [
		88545,
		8545
	],
	"./read": [
		49311,
		9311
	],
	"./read.tsx": [
		49311,
		9311
	],
	"./reflection": [
		83650,
		3650
	],
	"./reflection.tsx": [
		83650,
		3650
	],
	"./sortable": [
		50906,
		906
	],
	"./sortable.tsx": [
		50906,
		906
	],
	"./sortableColumns": [
		60711,
		711
	],
	"./sortableColumns.tsx": [
		60711,
		711
	],
	"./sound": [
		72994,
		2994
	],
	"./sound.tsx": [
		72994,
		2994
	],
	"./speaking": [
		28767,
		8767
	],
	"./speaking.tsx": [
		28767,
		8767
	],
	"./spotMistake": [
		93753,
		3753
	],
	"./spotMistake.tsx": [
		93753,
		3753
	],
	"./summary": [
		19163,
		9163
	],
	"./summary.tsx": [
		19163,
		9163
	],
	"./testYourself": [
		22677,
		2677
	],
	"./testYourself.tsx": [
		22677,
		2677
	],
	"./thoughtShower": [
		98684,
		8684
	],
	"./thoughtShower.tsx": [
		98684,
		8684
	],
	"./trueFalse": [
		59088,
		9088
	],
	"./trueFalse.tsx": [
		59088,
		9088
	],
	"./videoQuestion": [
		3425,
		3425
	],
	"./videoQuestion.tsx": [
		3425,
		3425
	],
	"./write": [
		40793,
		793
	],
	"./write.tsx": [
		40793,
		793
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 61639;
module.exports = webpackAsyncContext;